export default {
  relatedStories: {
    id: 'rm_metal_related_stories_title',
    defaultMessage: 'Related Stories',
  },
  readMore: { id: 'rm_metal_related_read_more', defaultMessage: 'Read More' },
} as const
